// AddTournament.js
import React, { useState } from 'react';
import axios from 'axios';
import config from "../../config/default.json";
import { Link, useNavigate } from 'react-router-dom';
import { useUtil } from '../Util';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser,faPenToSquare ,faVolleyball} from '@fortawesome/free-solid-svg-icons';

const base_url = config.base_url;
const token = localStorage.getItem('token');

const AddTournament = () => {

  const [name, setName] = useState('');
  const [startdate, setStartDate] = useState('');
  const [enddate, setEndDate] = useState('');
  const [acronym, setAcronym] = useState('');
  const [organization, setOrganization] = useState('');
  const [location, setLocation] = useState('');
  const [isPublished, setIsPublished] = useState(false);
  const [isCustomStanding, setIsCustomStanding] = useState(true);
  const [isCustomPlayoff, setIsCustomPlayoff] = useState(true);
    const navigate = useNavigate();
  const { getSlugPreview,toTitleCase } = useUtil();


  
 const slug = getSlugPreview(name, startdate);




const handleNameChange = (e) => {
  setName(e.target.value); // No formatting while typing
};




    const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };
    const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };


  const handleAcronymChange = (e) => {
    setAcronym(e.target.value);
  };


  const handleOrganizationChange = (e) => {
    setOrganization(e.target.value);
  };
  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  };
  const handleIsPublishedChange = (e) => {
    const isChecked = e.target.checked;
    setIsPublished(isChecked);
  };
  const handleIsCustomPlayoff = (e) => {
    const isChecked = e.target.checked;
    setIsCustomPlayoff(isChecked);
  };
  const handleIsCustomStanding = (e) => {
    const isChecked = e.target.checked;
    setIsCustomStanding(isChecked);
  };
  



  const handleSubmit = async (e) => {
    e.preventDefault();
  
  

    try {
      await axios.post(base_url +'/api/tournaments', { 
        slug,name,acronym,startdate,organization,location,
        isPublished,isCustomStanding,isCustomPlayoff },
         {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setName('');
      setStartDate('');
      setEndDate('');
      setOrganization('');
      setLocation('');
      setAcronym('');
      alert('Tournament added successfully!');
      navigate('/auth/profile');
    } catch (error) {
      console.error('Failed to add Tournament', error);
      alert('Failed to add Tournament'+error.response.data.error)
    }
  }



  return (
    <div>
        <Link to={`/auth/profile`} className="header-button">
                                  <FontAwesomeIcon icon={faUser} /> &nbsp; Profile
                                </Link>
        <br />                        
        <h1>
        <FontAwesomeIcon icon={faPenToSquare} size="1x"/> &nbsp;
      Create New Tournament</h1>
      <form onSubmit={handleSubmit}>
     
        <label>
          Name*: 
          <br />
          <input type="text" value={name} onChange={handleNameChange} required />
        </label><br />
        <br />
        <label>
          Start Date*: 
          <br />
          <input type="date" value={startdate} onChange={handleStartDateChange} required />
        </label>
         <br />
         <br />
          <small>
            🔗 Link preview: <strong>volleytally.com/{getSlugPreview(name, startdate)}</strong>
          </small><br />
          This is what the link will look like when you share it with others.
          <br />
        <br />
        <label>
          Acronym/Short Name*: <br />
          <small>This will be title of your homepage. Use year or frequency at the end of the name
             i.e. Champions Cup 2025 or Champions Cup Fall 2025</small>
             <br />
          <input type="text" value={acronym} onChange={handleAcronymChange}  required/>
        </label><br />
        <br />
        <label>
          End Date: 
          <br />
          <input type="date" value={enddate} onChange={handleEndDateChange}  />
        </label>
        <br />
        <br />
        <label>
          Organization Name:<br />
          <input type="text" value={organization} onChange={handleOrganizationChange} />
        </label><br />
        <br />
        <label>
          Location: <small>City or State etc.</small><br />
          <input type="text" value={location} onChange={handleLocationChange} />
        </label><br />
        <br />
        <label className="feedback-label">
          Publish now: <br />
          <small>if not checked, tournament will not show up on the homepage. 
            you can go to update tournament from admin page to publish it later.</small>
        <br />
          <input
            type="checkbox"
            checked={isPublished}
            onChange={handleIsPublishedChange} // Toggle the isReferee value
          />
        </label>
        {/* <label className="feedback-label">
          Custom Standings:
          <input
            type="checkbox"
            checked={isCustomStanding}
            onChange={handleIsCustomStanding} // Toggle the isReferee value
          />
        </label>
        <label className="feedback-label">
          Custom Playoff Brackets:
          <input
            type="checkbox"
            checked={isCustomPlayoff}
            onChange={handleIsCustomPlayoff} // Toggle the isReferee value
          />
        </label> */}

        <h3> Preview of Tournament Card on the home page</h3>

              <div className="card-container">
                
                    <div  className="tournament-card">
                      <table>
                                    <thead></thead>
                                    <tbody>
                                      <tr>
                                        <td  colSpan="2" style={{ fontWeight: 'bold', color: 'purple', fontSize: '20px', textAlign: 'center' }}>
                                          {name} 
                                        </td>
                                      </tr>
                                       <tr style={{ color: 'black' }}>
                                        <td colSpan="2" >
                                        Organization: {organization}
                                        </td>
                                      </tr>
                                      <tr style={{ color: 'black' }}>
                                        <td>
                                          Date: {startdate}
                                        </td>
                                        <td>
                                          Location: {location}
                                        </td>
                                      </tr>
                                      
                                        <tr>  
                                        <td style={{ color: 'black' }}>
                                         winner:
                                       </td>                
                                       <td style={{ fontWeight: 'bold', color: 'purple', fontSize: '20px' }}>
                                        TBD&nbsp; 
                                         </td>
                                     </tr>
                                      
                                      <tr>
                                      <td colSpan="2" style={{ textAlign: 'center' }}>
                                        <Link  className="select-button">
                                        <FontAwesomeIcon icon={faVolleyball}   /> 
                                        &nbsp;   {acronym}  &nbsp; 
                                          <FontAwesomeIcon icon={faVolleyball}  /> 
                                        </Link>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                    </div>
                
                
              </div>
        <br />
        <br />
        <button type="submit">Add Tournament</button>
                           
      </form>
    </div>
  );
};

export default AddTournament;
